import { Layout } from 'antd'
import Styled from 'styled-components'

const { Footer } = Layout

const S = {}

S.Footer = Styled(Footer)`
  text-align: center;
  box-shadow: 0px -5px 20px rgba(0, 0, 0, 0.1);
  background: hsl(210, 55%, 22%);
  color: white;
  padding: 12px 16px;
  @media (min-width: 768px) {
    padding: 16px 24px;
  }
`

export default S
